import { urlGlobal2 } from "./GlobalService";

export const getDatos = async() => {
    let token = localStorage.getItem('token');
    let headers = {'Content-Type':'application/json','token':token};
    const nResp = await fetch(`${urlGlobal2}/public/clientes/datos`,{headers,method:'GET'});
    const nData = await nResp.json();

    return nData;
}